module.exports = __webpack_public_path__ + "static/media/mv_concentrate.4c4348b1.jpg";